import { FieldPath, FieldValues } from 'react-hook-form';

import { TextField, TextFieldProps } from '.';


export function PhoneField<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({ countryCode, ...props }: TextFieldProps<TFieldValues, TName> & { countryCode?: boolean }) {
    return (
        <TextField
            {...props}
            rules={{
                ...props.rules,
                pattern: props.rules?.pattern || {
                    value: new RegExp(`\\d{${countryCode ? 11 : 10}}`),
                    message: 'Enter a valid phone number'
                }
            }}
            maskProps={{
                valueType: 'string',
                valueIsNumericString: true,
                format: `${countryCode ? '+#' : ''}(###) ###-####`,
                mask: '_',
                displayType: 'input',
                type: 'tel'
            }}
        />
    );
}
